<template>
  <div class="modal-card">
    <form v-on:submit.prevent='resetPass'>
      <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
      <header class="modal-card-head">
        <p class="modal-card-title">Resetear Password</p>
      </header>
      <section class="modal-card-body" v-if="!isLoading">
        <b-field label="Nueva Contraseña">
          <b-input required type='password' v-model='password'></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Cerrar</button>
        <button class="button is-primary" type="submit">Guardar Cambios</button>
      </footer>
    </form>
  </div>
</template>
<script>
import { changePassword } from "../../services/user";

export default {
  props: ["user_id"],
  data() {
    return {
      password: null,
      isLoading: false,
    };
  },
  methods: {
    async resetPass() {
      this.isLoading = true;
      let data={
          password:this.password
      }
      let response = await changePassword(this.$http, this.user_id,data);
      this.toast("La contraseña se ha cambiado correctamente", "is-success");
      console.log(response)
      this.isLoading = false;
      this.$parent.close()
    },
  },
};
</script>